import React, {PureComponent} from 'react';
import {withRouter} from 'react-router-dom';
/* Redux imports */
import {connect} from 'react-redux';
import {searchActions, searchSelectors} from "../../store/search";
/* styled-component imports */
import {Box, Card, Flex} from "rebass";
import {Input} from "reakit";
/* custom styled-components */
import {SearchButton} from "../Base/Buttons";
import styled from "styled-components";

const InputWrapper = styled(Box)`
	width: calc(100% - 45px);
	input:focus {
		outline: none;
	}
`

const ButtonWrapper = styled(Box)`
	min-width: 45px;
	max-width: 45px;
`


const SEARCH_ROUTES = [
	'/app/leaves/new',
	'/app/chat/new',
	'/app/posts/new',
	'/app/roster/new',
	'/app/search',
	'/app/dorm'
];

class SearchInput extends PureComponent {

	state = {
		redirect: false,
		searchTerm: '',
		hasSearch: false,
	};


	componentDidMount() {
		const hasSearch = this.pageHasSearch()

		this.setState({hasSearch})
	}


	handleSearchSubmit = (e) => {
		e.preventDefault();
		const {hasSearch} = this.state;
		const {history} = this.props;
		if(!hasSearch) history.push({pathname: '/app/search'})

	};

	handleSearchRedirect = (e) => {
		const {history} = this.props;

			history.push('/app/search')

	}

	pageHasSearch = () => {
		const hasSearch = SEARCH_ROUTES

		const location = this.props.location.pathname;
		let splitLocation = this.props.location.pathname.split('/');
		if(splitLocation.length === 4 && splitLocation[2] !== 'roster'){
			if(!hasSearch.includes(location)){
				return false
			}
		}
		if (splitLocation.length < 4 ){
			if(!hasSearch.includes(location)) return false
		}
		return true
	}

	handleSearchInput = (e) => {
		const {updateSearch} = this.props;
		e.preventDefault();
		updateSearch(e.target.value)
	};

	render() {
		const {search, placeholder} = this.props;
		const { hasSearch} = this.state;

		return (
			<Card bg={'white'}>
				<form onSubmit={this.handleSearchSubmit} style={{width: '100%'}}>
					<Flex width={1} flexWrap={'wrap'} flexDirection={'row'}>
						<ButtonWrapper >
							<SearchButton type={'submit'}/>
						</ButtonWrapper>
						<InputWrapper width={'90%'}>
							{hasSearch ?
								<Input fontWeight={'normal'} autoFocus={hasSearch} onChange={this.handleSearchInput} value={search} placeholder={placeholder} width={'100%'}/> :
								<Input fontWeight={'normal'} autoFocus={hasSearch} onChange={this.handleSearchInput} onFocus={this.handleSearchRedirect} value={search} placeholder={placeholder} width={'100%'}/>
							}
						</InputWrapper>
					</Flex>
				</form>
			</Card>
		);
	}
}


const mapStateToProps = state => ({
	search: searchSelectors.refreshSearch(state.search),
	placeholder: searchSelectors.refreshPlaceholder(state.search)
});

const mapDispatchToProps = dispatch => ({
	updateSearch: (term) => {
		dispatch(searchActions.updateSearch(term));
	},
	clearSearch: () => {
		dispatch(searchActions.clearSearch());
	},
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SearchInput));